export default __webpack_public_path__ + "static/media/share.de41d7c4.svg";